import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dealsReducer from './slices/dealsSlice';
import filterReducer from './slices/filterSlice';
import { Deal, FilterOptions } from '../types';

export interface RootState {
  auth: {
    user: any | null;
    session: any | null;
    isAdmin: boolean;
    loading: boolean;
    error: string | null;
  };
  deals: {
    deals: Deal[];
    loading: boolean;
    error: string | null;
    currentDeal: Deal | null;
    totalItems: number;
    totalPages: number;
  };
  filter: {
    options: FilterOptions;
  };
}

export const store = configureStore({
  reducer: {
    auth: authReducer,
    deals: dealsReducer,
    filter: filterReducer,
  },
});

export type AppDispatch = typeof store.dispatch; 